import { defineComponent } from 'vue';
export default defineComponent({
  name: 'ItemDetailBox',
  props: {
    title: {
      type: String,
      required: true
    },
    desc: {
      type: String,
      required: true
    }
  },
  setup: function () {
    return {};
  }
});